import { render, staticRenderFns } from "./addContractList.vue?vue&type=template&id=fa85412e&scoped=true"
import script from "./addContractList.vue?vue&type=script&lang=js"
export * from "./addContractList.vue?vue&type=script&lang=js"
import style0 from "./addContractList.vue?vue&type=style&index=0&id=fa85412e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa85412e",
  null
  
)

export default component.exports